import { ThemeConfig } from 'antd/es/config-provider/context';

import { Theme } from '../context';

/**
 * exports antd theme
 */
export function getTokenConfig(theme: Theme): ThemeConfig['token'] {
  return {
    fontFamily: theme.fonts.primary.family,
    colorPrimary: theme.colors.primary,
    colorPrimaryBg: theme.colors.primary,
    colorPrimaryHover: theme.colors.accent,
    colorText: theme.colors.body,
    colorLink: theme.colors.primary,
    colorLinkHover: theme.colors.accent,
    fontSize: 16,
  };
}

/**
 * exports button, input and switch
 */
export function getComponentsConfig(theme: Theme): ThemeConfig['components'] {
  return {
    Button: {
      controlHeight: 48,
      controlHeightSM: 32,
      controlHeightLG: 56,
      borderRadius: 50,
      colorText: theme.colors.primary,
      fontWeight: 500,
      fontWeightStrong: 700,
    },
    Input: {
      controlHeight: 40,
    },
  };
}
